export enum RpOccurrenceStatusEnum {
  FAILED_RESOLVED = 'FAILED_RESOLVED',
  FAILED_UNRESOLVED = 'FAILED_UNRESOLVED',
  PENDING = 'PENDING',
  REFUNDED_FULL = 'REFUNDED_FULL',
  REFUNDED_PARTIAL = 'REFUNDED_PARTIAL',
  SKIPPED = 'SKIPPED',
  SUCCESS = 'SUCCESS'
}

export const PRETTY_RP_OCCURRENCE_STATUS = {
  [RpOccurrenceStatusEnum.FAILED_RESOLVED]: 'Failed: Resolved',
  [RpOccurrenceStatusEnum.FAILED_UNRESOLVED]: 'Failed: Unresolved',
  [RpOccurrenceStatusEnum.PENDING]: 'Pending',
  [RpOccurrenceStatusEnum.REFUNDED_FULL]: 'Refunded: Full',
  [RpOccurrenceStatusEnum.REFUNDED_PARTIAL]: 'Refunded: Partial',
  [RpOccurrenceStatusEnum.SKIPPED]: 'Skipped',
  [RpOccurrenceStatusEnum.SUCCESS]: 'Success'
}
